import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;

export const getFabricasByProveedor = async (CODPROV) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_URL}/api/fabricas/${CODPROV}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

/** Mismos nombres que usa la logística legacy (ProductionTimeline). */
export const getFabricasNombresByProveedorNombre = async (nombre) => {
  const token = localStorage.getItem("token");
  const name = String(nombre || "").trim();
  if (!name) return [];
  const response = await axios.get(
    `${API_URL}/api/productionTimeline/proveedor/${encodeURIComponent(name)}/fabricas`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return Array.isArray(response.data) ? response.data : [];
};

export const addFabrica = async (fabrica) => {
  const token = localStorage.getItem("token");

  const response = await axios.post(`${API_URL}/api/fabricas`, fabrica, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  return response.data;
};

export const deleteRelacionProveedorFabrica = async (CODPROV, id_Fabrica) => {
  const token = localStorage.getItem("token");

  await axios.delete(
    `${API_URL}/api/proveedorFabricas/${CODPROV}/${id_Fabrica}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

// ✅ Obtener fábricas NO asociadas a un proveedor
export const getFabricasNoAsociadas = async (CODPROV) => {
  const token = localStorage.getItem("token");

  try {
    const response = await axios.get(
      `${API_URL}/api/proveedorFabricas/fabricas/no-asociadas/${CODPROV}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("❌ Error en getFabricasNoAsociadas:", error);
    return [];
  }
};

// ✅ Asociar una fábrica existente a un proveedor
export const asociarFabricaAProveedor = async (CODPROV, id_Fabrica) => {
  const token = localStorage.getItem("token");
  const response = await axios.post(
    `${API_URL}/api/proveedorFabricas/asociar`,
    { CODPROV, id_Fabrica },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

/* Actualiza Fabricas */
export const updateFabrica = async (fabrica) => {
  const token = localStorage.getItem("token");

  try {
    const response = await axios.put(
      `${API_URL}/api/fabricas/${fabrica.id_Fabrica}`,
      fabrica,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("❌ Error en updateFabrica:", error.response?.data || error);
    throw error;
  }
};

// 🔹 Obtener tipos de fábrica
export const getFabricasTipo = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API_URL}/api/fabricasTipo`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("❌ Error en getFabricasTipo:", error);
    return [];
  }
};

// 🔹 Obtener todas las fábricas con su tipo y país
export const getFabricas = async () => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_URL}/api/fabricas`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

// 🔹 Crear una fábrica SIN proveedor
export const addFabricaSinProveedor = async (fabrica) => {
  const token = localStorage.getItem("token");

  const response = await axios.post(
    `${API_URL}/api/fabricas-sin-proveedor`, // ✅ Usamos el nuevo endpoint
    fabrica,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );

  return response.data;
};
